export const warmUpHeadersData = [
  {
    text: 'Name',
    value: 'name'
  },
  {
    text: 'Questions Type',
    value: 'type'
  },
  {
    text: 'Summary',
    value: 'summary'
  },
  {
    text: 'Instructions',
    value: 'instructions'
  },
  {
    text: 'Active',
    value: 'active'
  }
];
